import { render, staticRenderFns } from "./BlogJournal.vue?vue&type=template&id=42dba5d8&"
import script from "./BlogJournal.vue?vue&type=script&lang=js&"
export * from "./BlogJournal.vue?vue&type=script&lang=js&"
import style0 from "./BlogJournal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports